import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {EvictionSettingModel} from '../Models/criminal-model';
import {environment} from '../../../environments/environment';
import {ObjectUpdatePayload} from '../../models/screeningInvite';
import {tap} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class DecisionGridEvictionService {

  public evictionSettings: EvictionSettingModel[] = [];
  public evictionSettingsSubscription$ = new BehaviorSubject<EvictionSettingModel[]>([]);

  constructor(private http: HttpClient, private toast: ToastrService) {
  }

  public getEvictionSettings(clientId: number): Observable<EvictionSettingModel[]> {
    return this.http.get<EvictionSettingModel[]>(`${environment.baseURl}/api/decisionGrid/EvictionSetting/GetEvictionSettings/${clientId}`)
      .pipe(tap((r: EvictionSettingModel[]) => {
        this.evictionSettings = r;
        this.evictionSettingsSubscription$.next(r);
      },
      err => {
        this.toast.error('Error fetching eviction settings!', '', { closeButton: true, disableTimeOut: true })
      }));
  }

  public insertEvictionSetting(clientId: number, data: EvictionSettingModel): Observable<any> {

    const p = {
      data: data,
    };

    return this.http.post<EvictionSettingModel>(`${environment.baseURl}/api/decisionGrid/EvictionSetting/InsertEvictionSetting/${clientId}`, data)
      .pipe(tap((r: EvictionSettingModel) => {
        // this.getEvictionSettings(clientId).subscribe()
        // Add the new model to the cache
        this.evictionSettings.push(r);
      },
      err => {
        this.toast.error('Error saving eviction setting!', '', { closeButton: true, disableTimeOut: true })
      }));

  }

  public updateEvictionSetting(clientId: number, data: EvictionSettingModel): Observable<any> {
    // const p = {
    //   data: data,
    //   payload: data,
    // };

    let settingId = data.settingId;

    return this.http.post<EvictionSettingModel>(`${environment.baseURl}/api/decisionGrid/EvictionSetting/UpdateEvictionSetting/${clientId}/${settingId}`, data)
      .pipe(tap((r: EvictionSettingModel) => {
        // this.getEvictionSettings(clientId).subscribe()
        // Now update the existing model.

      },
      err => {
        this.toast.error('Error updating eviction settings!', '', { closeButton: true, disableTimeOut: true })
      }));
  }

  public deleteEvictionSetting(clientId: number, settingId: number): Observable<any> {
    return this.http.delete<any>(`${environment.baseURl}/api/decisionGrid/EvictionSetting/DeleteEvictionSetting/${clientId}/${settingId}`)
      .pipe(tap(() => {
        // Remove this from the original load
        const idx = this.evictionSettings.findIndex(g => {
          return g.settingId === settingId;
        });

        if (idx >= 0) {
          this.evictionSettings.splice(idx, 1);
        }

      },
      err => {
        this.toast.error('Error deleting eviction setting!', '', { closeButton: true, disableTimeOut: true })
      }));
  }
}

